<template>
  <div class="landing-convenience">
    <div class="landing-convenience__container">
      <div class="landing-convenience__image-container">
        <img
          class="landing-convenience__image"
          :src="convenienceImage"
          :alt="$t('b2b__landing_page__convenience__title')"
        />
      </div>

      <div class="landing-convenience__content">
        <h2 class="landing-convenience__title">
          {{ $t('b2b__landing_page__convenience__title') }}
        </h2>

        <ul class="landing-convenience__list">
          <li
            v-for="(item, index) in items"
            :key="index"
            class="landing-convenience__list-item"
          >
            {{ $t(item) }}
          </li>
        </ul>

        <BaseButton
          class="landing-convenience__cta"
          @click="handleCTAButtonClick"
        >
          {{ ctaBtnTitle }}
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<script setup>
import BaseButton from '@shared/components/BaseButton.vue'
import convenienceImage from '@shared/assets/img/convenience-highlight.png'

defineProps({
  ctaBtnTitle: {
    type: String,
    default: '',
  },
  handleCTAButtonClick: {
    type: Function,
    default: () => {},
  },
})

const items = [
  'b2b__landing_page__convenience__item_one',
  'b2b__landing_page__convenience__item_two',
  'b2b__landing_page__convenience__item_three',
  'b2b__landing_page__convenience__item_four',
]
</script>

<style lang="scss" scoped>
.landing-convenience {
  background-color: $kds-color-background-base;
  padding: 40px 10px;

  @include media-up(lg) {
    padding: 72px 10px;
  }

  &__container {
    @extend %container;
    @include flex-container(column, flex-start, lg);
    margin: 0 auto;

    @include media-up(md) {
      @include flex-container(row, space-between, xl, stretch);
    }
  }

  &__image-container {
    width: 100%;
    max-width: 420px;
    border-radius: 16px;
    overflow: hidden;
    background-color: $kds-color-background-base;

    @include media-up(md) {
      width: 40%;
      max-width: none;
      align-self: stretch;
    }
  }

  &__image {
    display: block;
    box-sizing: border-box;
    width: 100%;
    height: auto;
    object-fit: cover;
    object-position: center;

    @include media-up(md) {
      height: 100%;
    }
  }

  &__content {
    width: 100%;

    @include media-up(md) {
      width: 56%;
    }
  }

  &__title {
    @include kds-typography-display-small;
    font-weight: $kds-typography-font-weight-medium;
    margin: $kds-space-2x 0 $kds-space-1_5x;

    @include media-up(md) {
      @include kds-typography-display-medium;
      font-weight: $kds-typography-font-weight-medium;
      margin-top: 0;
    }
  }

  &__list {
    margin: 0;
    padding: 0;
    list-style: none;
    text-align: left;
  }

  &__list-item {
    @include kds-typography-paragraph-large;
    padding-left: 22px;
    position: relative;
    text-align: left;

    &:not(:first-child) {
      margin-top: 10px;
    }

    &::before {
      content: '';
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: $kds-color-background-interactive-accent;
      position: absolute;
      top: 10px;
      left: 0;
    }
  }

  &__cta {
    margin-top: $kds-space-3x;
    width: max-content;
    margin-inline: auto;

    @include media-up(md) {
      margin-inline: 0;
    }
  }
}
</style>
